import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconVisibility, IconVisibilityOff } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { ActionLink, Stack, TextField } from '../../../primitives/index.js';
export const PasswordField = restProps => {
  const {
    t
  } = useTranslation('authentication');
  const [isVisible, setIsVisible] = useState(false);
  const handleButtonClick = () => setIsVisible(previous => !previous);
  return _jsx(TextField, {
    type: isVisible ? 'text' : 'password',
    appendIcon: _jsx(Stack, {
      children: _jsx(ActionLink, {
        "aria-label": t(isVisible ? 'passwordContent.ariaLabels.hidePassword' : 'passwordContent.ariaLabels.showPassword'),
        color: "contentSecondary",
        onClick: handleButtonClick,
        children: isVisible ? _jsx(IconVisibility, {}) : _jsx(IconVisibilityOff, {})
      })
    }),
    ...restProps
  });
};